import * as React from "react";

const AndroidQR = () => {
  return (
    <svg
      width="203"
      height="242"
      viewBox="0 0 203 242"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2218_7445)">
        <rect
          width="200"
          height="200"
          transform="translate(1.5 1)"
          fill="white"
        />
        <path
          d="M101.5 77.7998C96.9116 77.7998 92.4264 79.1603 88.6113 81.7092C84.7962 84.2582 81.8226 87.8812 80.0665 92.12C78.3103 96.3589 77.8505 101.023 78.7451 105.523C79.6397 110.024 81.8487 114.157 85.0926 117.402C88.3365 120.647 92.4697 122.857 96.9696 123.753C101.47 124.649 106.134 124.191 110.373 122.436C114.613 120.681 118.237 117.708 120.787 113.894C123.337 110.08 124.698 105.595 124.7 101.006C124.699 94.8536 122.255 88.9529 117.904 84.6021C113.553 80.2514 107.653 77.8069 101.5 77.8065M112.388 86.4335C112.737 86.3147 112.952 86.6377 113.173 86.8251C114.54 87.9966 115.208 89.5596 115.728 91.2265C115.936 91.8842 115.842 92.2942 115.184 92.577C114.737 92.7711 114.296 93.2832 113.917 93.2263C113.571 93.1728 113.556 92.4414 113.363 92.0197C112.601 90.3549 111.485 88.8767 110.092 87.6886C109.969 87.5799 109.849 87.4694 109.73 87.3539C109.718 87.3439 109.73 87.3154 109.718 87.2552C110.569 86.877 111.506 86.7347 112.388 86.4285M87.8974 103.78C87.1293 105.058 86.9519 106.429 87.3536 107.977C86.5168 107.682 85.7721 107.413 85.0106 107.157C84.9067 107.129 84.8142 107.069 84.7463 106.985C84.6784 106.902 84.6386 106.799 84.6324 106.691C84.4344 105.353 84.6129 103.986 85.1478 102.744C85.2767 102.426 85.429 102.319 85.7637 102.467C86.4331 102.767 87.1025 103.043 87.7719 103.324C88.0146 103.426 88.0347 103.544 87.8941 103.78M117.556 107.701C117.465 108.396 117.013 108.932 116.198 109.309C115.779 109.528 115.313 109.643 114.839 109.644C114.476 109.642 114.119 109.543 113.807 109.356C113.535 109.188 113.334 108.926 113.245 108.619C113.15 108.256 113.181 107.871 113.332 107.527C112.732 106.457 111.941 105.506 110.999 104.722C110.96 106.559 110.663 108.152 110.11 109.5C109.615 110.753 108.917 111.915 108.045 112.942C107.282 113.837 106.378 114.601 105.367 115.203C104.512 115.718 103.6 116.133 102.65 116.441C101.364 116.856 100.031 117.107 98.6833 117.188C97.5268 117.26 96.3672 117.114 95.2643 116.759C94.2168 116.411 93.2744 115.803 92.5247 114.992C91.7438 114.164 91.1251 113.089 90.6688 111.766C90.0875 110.165 89.9202 108.676 90.1667 107.299C90.3906 105.965 90.9275 104.703 91.7332 103.617C92.5825 102.49 93.6362 101.532 94.8392 100.794C96.1443 99.9781 97.5509 99.3372 99.023 98.8878C101.205 98.2061 103.197 97.8904 104.999 97.9406C104.04 95.5218 102.571 93.8996 100.594 93.074C98.6174 92.2484 95.8283 92.2523 92.2268 93.0857C91.6286 93.2203 91.0086 93.2266 90.4077 93.1041C89.7601 92.9803 89.3417 92.5435 89.1476 91.7921C89.0771 91.5374 89.0638 91.2704 89.1087 91.01C89.1535 90.7496 89.2554 90.5023 89.407 90.2859C89.7182 89.8452 90.3542 89.4748 91.3148 89.1747C94.0895 88.3134 96.544 87.9263 98.6783 88.0133C100.813 88.1003 102.658 88.5912 104.216 89.486C105.797 90.4079 107.12 91.7125 108.065 93.2799C109.138 95.0528 109.915 96.9888 110.364 99.0117C111.846 99.6568 113.188 100.584 114.316 101.741C115.339 102.791 116.217 103.973 116.926 105.256C117.428 106.196 117.626 107.016 117.54 107.712M103.215 102.151C102.246 102.21 101.286 102.367 100.348 102.618C99.4976 102.878 98.6791 103.233 97.9084 103.677C97.2077 104.079 96.5842 104.602 96.0676 105.222C95.6003 105.789 95.2668 106.455 95.0919 107.168C94.9252 107.904 94.9634 108.671 95.2024 109.386C95.6274 110.755 96.3677 111.703 97.4231 112.231C98.4786 112.758 99.7091 112.803 101.115 112.363C101.916 112.107 102.669 111.718 103.342 111.213C104.072 110.666 104.686 109.979 105.15 109.193C105.673 108.287 106.024 107.291 106.182 106.256C106.379 104.976 106.375 103.673 106.171 102.394C105.198 102.181 104.201 102.101 103.207 102.158M99.5585 109.597C99.2674 109.597 98.9828 109.511 98.7406 109.349C98.4985 109.188 98.3097 108.958 98.1981 108.689C98.0866 108.42 98.0573 108.125 98.114 107.839C98.1707 107.554 98.3108 107.291 98.5167 107.085C98.7225 106.88 98.9848 106.74 99.2703 106.683C99.5558 106.626 99.8517 106.655 100.121 106.767C100.389 106.878 100.619 107.067 100.781 107.309C100.942 107.552 101.028 107.836 101.028 108.127C101.028 108.517 100.873 108.891 100.598 109.166C100.322 109.442 99.9482 109.597 99.5585 109.597Z"
          fill="#604EA0"
        />
        <path d="M10 9H14.973V13.973H10V9Z" fill="#1D153A" />
        <path d="M14.973 9H19.9459V13.973H14.973V9Z" fill="#1D153A" />
        <path d="M19.9459 9H24.9189V13.973H19.9459V9Z" fill="#1D153A" />
        <path d="M24.9189 9H29.8919V13.973H24.9189V9Z" fill="#1D153A" />
        <path d="M29.8919 9H34.8649V13.973H29.8919V9Z" fill="#1D153A" />
        <path d="M34.8649 9H39.8378V13.973H34.8649V9Z" fill="#1D153A" />
        <path d="M39.8378 9H44.8108V13.973H39.8378V9Z" fill="#1D153A" />
        <path d="M49.7838 9H54.7568V13.973H49.7838V9Z" fill="#1D153A" />
        <path d="M54.7568 9H59.7297V13.973H54.7568V9Z" fill="#1D153A" />
        <path d="M84.5946 9H89.5676V13.973H84.5946V9Z" fill="#1D153A" />
        <path d="M94.5405 9H99.5135V13.973H94.5405V9Z" fill="#1D153A" />
        <path d="M104.486 9H109.459V13.973H104.486V9Z" fill="#1D153A" />
        <path d="M109.459 9H114.432V13.973H109.459V9Z" fill="#1D153A" />
        <path d="M114.432 9H119.405V13.973H114.432V9Z" fill="#1D153A" />
        <path d="M119.405 9H124.378V13.973H119.405V9Z" fill="#1D153A" />
        <path d="M134.324 9H139.297V13.973H134.324V9Z" fill="#1D153A" />
        <path d="M139.297 9H144.27V13.973H139.297V9Z" fill="#1D153A" />
        <path d="M144.27 9H149.243V13.973H144.27V9Z" fill="#1D153A" />
        <path d="M159.189 9H164.162V13.973H159.189V9Z" fill="#1D153A" />
        <path d="M164.162 9H169.135V13.973H164.162V9Z" fill="#1D153A" />
        <path d="M169.135 9H174.108V13.973H169.135V9Z" fill="#1D153A" />
        <path d="M174.108 9H179.081V13.973H174.108V9Z" fill="#1D153A" />
        <path d="M179.081 9H184.054V13.973H179.081V9Z" fill="#1D153A" />
        <path d="M184.054 9H189.027V13.973H184.054V9Z" fill="#1D153A" />
        <path d="M189.027 9H194V13.973H189.027V9Z" fill="#1D153A" />
        <path d="M10 13.973H14.973V18.9459H10V13.973Z" fill="#1D153A" />
        <path
          d="M39.8378 13.973H44.8108V18.9459H39.8378V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 13.973H54.7568V18.9459H49.7838V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 13.973H69.6757V18.9459H64.7027V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M74.6487 13.973H79.6216V18.9459H74.6487V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 13.973H84.5946V18.9459H79.6216V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M89.5676 13.973H94.5405V18.9459H89.5676V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 13.973H104.486V18.9459H99.5135V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M109.459 13.973H114.432V18.9459H109.459V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M119.405 13.973H124.378V18.9459H119.405V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 13.973H134.324V18.9459H129.351V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 13.973H139.297V18.9459H134.324V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 13.973H144.27V18.9459H139.297V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 13.973H149.243V18.9459H144.27V13.973Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 13.973H164.162V18.9459H159.189V13.973Z"
          fill="#1D153A"
        />
        <path d="M189.027 13.973H194V18.9459H189.027V13.973Z" fill="#1D153A" />
        <path d="M10 18.9459H14.973V23.9189H10V18.9459Z" fill="#1D153A" />
        <path
          d="M19.9459 18.9459H24.9189V23.9189H19.9459V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 18.9459H29.8919V23.9189H24.9189V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 18.9459H34.8649V23.9189H29.8919V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 18.9459H44.8108V23.9189H39.8378V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 18.9459H59.7297V23.9189H54.7568V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 18.9459H64.7027V23.9189H59.7297V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 18.9459H74.6487V23.9189H69.6757V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 18.9459H89.5676V23.9189H84.5946V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 18.9459H99.5135V23.9189H94.5405V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 18.9459H109.459V23.9189H104.486V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M119.405 18.9459H124.378V23.9189H119.405V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 18.9459H134.324V23.9189H129.351V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 18.9459H144.27V23.9189H139.297V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 18.9459H164.162V23.9189H159.189V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 18.9459H174.108V23.9189H169.135V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 18.9459H179.081V23.9189H174.108V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 18.9459H184.054V23.9189H179.081V18.9459Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 18.9459H194V23.9189H189.027V18.9459Z"
          fill="#1D153A"
        />
        <path d="M10 23.9189H14.973V28.8919H10V23.9189Z" fill="#1D153A" />
        <path
          d="M19.9459 23.9189H24.9189V28.8919H19.9459V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 23.9189H29.8919V28.8919H24.9189V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 23.9189H34.8649V28.8919H29.8919V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 23.9189H44.8108V28.8919H39.8378V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 23.9189H54.7568V28.8919H49.7838V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 23.9189H84.5946V28.8919H79.6216V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 23.9189H89.5676V28.8919H84.5946V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M89.5676 23.9189H94.5405V28.8919H89.5676V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 23.9189H99.5135V28.8919H94.5405V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 23.9189H109.459V28.8919H104.486V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M109.459 23.9189H114.432V28.8919H109.459V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M124.378 23.9189H129.351V28.8919H124.378V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 23.9189H134.324V28.8919H129.351V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 23.9189H144.27V28.8919H139.297V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 23.9189H154.216V28.8919H149.243V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 23.9189H164.162V28.8919H159.189V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 23.9189H174.108V28.8919H169.135V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 23.9189H179.081V28.8919H174.108V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 23.9189H184.054V28.8919H179.081V23.9189Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 23.9189H194V28.8919H189.027V23.9189Z"
          fill="#1D153A"
        />
        <path d="M10 28.8919H14.973V33.8649H10V28.8919Z" fill="#1D153A" />
        <path
          d="M19.9459 28.8919H24.9189V33.8649H19.9459V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 28.8919H29.8919V33.8649H24.9189V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 28.8919H34.8649V33.8649H29.8919V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 28.8919H44.8108V33.8649H39.8378V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 28.8919H54.7568V33.8649H49.7838V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 28.8919H59.7297V33.8649H54.7568V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 28.8919H74.6487V33.8649H69.6757V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M74.6487 28.8919H79.6216V33.8649H74.6487V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 28.8919H84.5946V33.8649H79.6216V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 28.8919H89.5676V33.8649H84.5946V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 28.8919H99.5135V33.8649H94.5405V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 28.8919H104.486V33.8649H99.5135V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 28.8919H109.459V33.8649H104.486V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M114.432 28.8919H119.405V33.8649H114.432V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M119.405 28.8919H124.378V33.8649H119.405V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M124.378 28.8919H129.351V33.8649H124.378V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 28.8919H139.297V33.8649H134.324V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 28.8919H144.27V33.8649H139.297V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 28.8919H149.243V33.8649H144.27V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 28.8919H154.216V33.8649H149.243V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 28.8919H164.162V33.8649H159.189V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 28.8919H174.108V33.8649H169.135V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 28.8919H179.081V33.8649H174.108V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 28.8919H184.054V33.8649H179.081V28.8919Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 28.8919H194V33.8649H189.027V28.8919Z"
          fill="#1D153A"
        />
        <path d="M10 33.8649H14.973V38.8378H10V33.8649Z" fill="#1D153A" />
        <path
          d="M39.8378 33.8649H44.8108V38.8378H39.8378V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 33.8649H54.7568V38.8378H49.7838V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M89.5676 33.8649H94.5405V38.8378H89.5676V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 33.8649H99.5135V38.8378H94.5405V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 33.8649H109.459V38.8378H104.486V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M109.459 33.8649H114.432V38.8378H109.459V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M124.378 33.8649H129.351V38.8378H124.378V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 33.8649H134.324V38.8378H129.351V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 33.8649H139.297V38.8378H134.324V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 33.8649H144.27V38.8378H139.297V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 33.8649H149.243V38.8378H144.27V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 33.8649H154.216V38.8378H149.243V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 33.8649H164.162V38.8378H159.189V33.8649Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 33.8649H194V38.8378H189.027V33.8649Z"
          fill="#1D153A"
        />
        <path d="M10 38.8378H14.973V43.8108H10V38.8378Z" fill="#1D153A" />
        <path
          d="M14.973 38.8378H19.9459V43.8108H14.973V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M19.9459 38.8378H24.9189V43.8108H19.9459V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 38.8378H29.8919V43.8108H24.9189V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 38.8378H34.8649V43.8108H29.8919V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 38.8378H39.8378V43.8108H34.8649V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 38.8378H44.8108V43.8108H39.8378V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 38.8378H54.7568V43.8108H49.7838V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 38.8378H64.7027V43.8108H59.7297V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 38.8378H74.6487V43.8108H69.6757V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 38.8378H84.5946V43.8108H79.6216V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M89.5676 38.8378H94.5405V43.8108H89.5676V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 38.8378H104.486V43.8108H99.5135V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M109.459 38.8378H114.432V43.8108H109.459V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M119.405 38.8378H124.378V43.8108H119.405V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 38.8378H134.324V43.8108H129.351V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 38.8378H144.27V43.8108H139.297V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 38.8378H154.216V43.8108H149.243V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 38.8378H164.162V43.8108H159.189V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 38.8378H169.135V43.8108H164.162V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 38.8378H174.108V43.8108H169.135V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 38.8378H179.081V43.8108H174.108V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 38.8378H184.054V43.8108H179.081V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 38.8378H189.027V43.8108H184.054V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 38.8378H194V43.8108H189.027V38.8378Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 43.8108H64.7027V48.7838H59.7297V43.8108Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 43.8108H69.6757V48.7838H64.7027V43.8108Z"
          fill="#1D153A"
        />
        <path
          d="M74.6487 43.8108H79.6216V48.7838H74.6487V43.8108Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 43.8108H84.5946V48.7838H79.6216V43.8108Z"
          fill="#1D153A"
        />
        <path
          d="M89.5676 43.8108H94.5405V48.7838H89.5676V43.8108Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 43.8108H109.459V48.7838H104.486V43.8108Z"
          fill="#1D153A"
        />
        <path
          d="M109.459 43.8108H114.432V48.7838H109.459V43.8108Z"
          fill="#1D153A"
        />
        <path
          d="M119.405 43.8108H124.378V48.7838H119.405V43.8108Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 43.8108H134.324V48.7838H129.351V43.8108Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 43.8108H144.27V48.7838H139.297V43.8108Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 48.7838H29.8919V53.7568H24.9189V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 48.7838H44.8108V53.7568H39.8378V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 48.7838H84.5946V53.7568H79.6216V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 48.7838H89.5676V53.7568H84.5946V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M89.5676 48.7838H94.5405V53.7568H89.5676V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M114.432 48.7838H119.405V53.7568H114.432V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M124.378 48.7838H129.351V53.7568H124.378V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 48.7838H149.243V53.7568H144.27V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 48.7838H154.216V53.7568H149.243V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 48.7838H169.135V53.7568H164.162V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 48.7838H174.108V53.7568H169.135V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 48.7838H179.081V53.7568H174.108V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 48.7838H189.027V53.7568H184.054V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 48.7838H194V53.7568H189.027V48.7838Z"
          fill="#1D153A"
        />
        <path
          d="M19.9459 53.7568H24.9189V58.7297H19.9459V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 53.7568H29.8919V58.7297H24.9189V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 53.7568H34.8649V58.7297H29.8919V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 53.7568H54.7568V58.7297H49.7838V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 53.7568H64.7027V58.7297H59.7297V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 53.7568H74.6487V58.7297H69.6757V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 53.7568H89.5676V58.7297H84.5946V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 53.7568H104.486V58.7297H99.5135V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 53.7568H109.459V58.7297H104.486V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M109.459 53.7568H114.432V58.7297H109.459V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M119.405 53.7568H124.378V58.7297H119.405V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M124.378 53.7568H129.351V58.7297H124.378V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 53.7568H134.324V58.7297H129.351V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 53.7568H139.297V58.7297H134.324V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 53.7568H144.27V58.7297H139.297V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 53.7568H149.243V58.7297H144.27V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 53.7568H154.216V58.7297H149.243V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 53.7568H159.189V58.7297H154.216V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 53.7568H169.135V58.7297H164.162V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 53.7568H184.054V58.7297H179.081V53.7568Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 53.7568H194V58.7297H189.027V53.7568Z"
          fill="#1D153A"
        />
        <path d="M10 58.7297H14.973V63.7027H10V58.7297Z" fill="#1D153A" />
        <path
          d="M19.9459 58.7297H24.9189V63.7027H19.9459V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 58.7297H29.8919V63.7027H24.9189V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 58.7297H34.8649V63.7027H29.8919V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 58.7297H39.8378V63.7027H34.8649V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 58.7297H44.8108V63.7027H39.8378V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 58.7297H59.7297V63.7027H54.7568V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 58.7297H64.7027V63.7027H59.7297V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 58.7297H69.6757V63.7027H64.7027V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M74.6487 58.7297H79.6216V63.7027H74.6487V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 58.7297H84.5946V63.7027H79.6216V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 58.7297H89.5676V63.7027H84.5946V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M89.5676 58.7297H94.5405V63.7027H89.5676V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 58.7297H104.486V63.7027H99.5135V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 58.7297H109.459V63.7027H104.486V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M109.459 58.7297H114.432V63.7027H109.459V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M124.378 58.7297H129.351V63.7027H124.378V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 58.7297H149.243V63.7027H144.27V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 58.7297H164.162V63.7027H159.189V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 58.7297H169.135V63.7027H164.162V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 58.7297H174.108V63.7027H169.135V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 58.7297H189.027V63.7027H184.054V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 58.7297H194V63.7027H189.027V58.7297Z"
          fill="#1D153A"
        />
        <path
          d="M14.973 63.7027H19.9459V68.6757H14.973V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M19.9459 63.7027H24.9189V68.6757H19.9459V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 63.7027H29.8919V68.6757H24.9189V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 63.7027H34.8649V68.6757H29.8919V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 63.7027H39.8378V68.6757H34.8649V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 63.7027H54.7568V68.6757H49.7838V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 63.7027H69.6757V68.6757H64.7027V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M74.6487 63.7027H79.6216V68.6757H74.6487V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 63.7027H99.5135V68.6757H94.5405V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 63.7027H104.486V68.6757H99.5135V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 63.7027H109.459V68.6757H104.486V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M124.378 63.7027H129.351V68.6757H124.378V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 63.7027H139.297V68.6757H134.324V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 63.7027H154.216V68.6757H149.243V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 63.7027H174.108V68.6757H169.135V63.7027Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 63.7027H194V68.6757H189.027V63.7027Z"
          fill="#1D153A"
        />
        <path d="M10 68.6757H14.973V73.6487H10V68.6757Z" fill="#1D153A" />
        <path
          d="M14.973 68.6757H19.9459V73.6487H14.973V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M19.9459 68.6757H24.9189V73.6487H19.9459V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 68.6757H29.8919V73.6487H24.9189V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 68.6757H34.8649V73.6487H29.8919V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 68.6757H44.8108V73.6487H39.8378V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 68.6757H54.7568V73.6487H49.7838V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 68.6757H64.7027V73.6487H59.7297V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 68.6757H84.5946V73.6487H79.6216V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 68.6757H89.5676V73.6487H84.5946V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 68.6757H99.5135V73.6487H94.5405V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M114.432 68.6757H119.405V73.6487H114.432V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M119.405 68.6757H124.378V73.6487H119.405V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 68.6757H139.297V73.6487H134.324V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 68.6757H149.243V73.6487H144.27V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 68.6757H154.216V73.6487H149.243V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 68.6757H164.162V73.6487H159.189V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 68.6757H189.027V73.6487H184.054V68.6757Z"
          fill="#1D153A"
        />
        <path
          d="M14.973 73.6487H19.9459V78.6216H14.973V73.6487Z"
          fill="#1D153A"
        />
        <path
          d="M19.9459 73.6487H24.9189V78.6216H19.9459V73.6487Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 73.6487H69.6757V78.6216H64.7027V73.6487Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 73.6487H74.6487V78.6216H69.6757V73.6487Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 73.6487H134.324V78.6216H129.351V73.6487Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 73.6487H144.27V78.6216H139.297V73.6487Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 73.6487H154.216V78.6216H149.243V73.6487Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 73.6487H164.162V78.6216H159.189V73.6487Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 73.6487H169.135V78.6216H164.162V73.6487Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 73.6487H179.081V78.6216H174.108V73.6487Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 73.6487H189.027V78.6216H184.054V73.6487Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 73.6487H194V78.6216H189.027V73.6487Z"
          fill="#1D153A"
        />
        <path d="M10 78.6216H14.973V83.5946H10V78.6216Z" fill="#1D153A" />
        <path
          d="M24.9189 78.6216H29.8919V83.5946H24.9189V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 78.6216H34.8649V83.5946H29.8919V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 78.6216H44.8108V83.5946H39.8378V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M44.8108 78.6216H49.7838V83.5946H44.8108V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 78.6216H54.7568V83.5946H49.7838V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 78.6216H69.6757V83.5946H64.7027V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 78.6216H74.6487V83.5946H69.6757V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 78.6216H134.324V83.5946H129.351V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 78.6216H144.27V83.5946H139.297V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 78.6216H159.189V83.5946H154.216V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 78.6216H164.162V83.5946H159.189V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 78.6216H174.108V83.5946H169.135V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 78.6216H184.054V83.5946H179.081V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 78.6216H194V83.5946H189.027V78.6216Z"
          fill="#1D153A"
        />
        <path
          d="M19.9459 83.5946H24.9189V88.5676H19.9459V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 83.5946H29.8919V88.5676H24.9189V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 83.5946H39.8378V88.5676H34.8649V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M44.8108 83.5946H49.7838V88.5676H44.8108V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 83.5946H64.7027V88.5676H59.7297V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 83.5946H69.6757V88.5676H64.7027V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 83.5946H134.324V88.5676H129.351V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 83.5946H139.297V88.5676H134.324V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 83.5946H144.27V88.5676H139.297V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 83.5946H149.243V88.5676H144.27V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 83.5946H154.216V88.5676H149.243V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 83.5946H174.108V88.5676H169.135V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 83.5946H189.027V88.5676H184.054V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 83.5946H194V88.5676H189.027V83.5946Z"
          fill="#1D153A"
        />
        <path
          d="M14.973 88.5676H19.9459V93.5405H14.973V88.5676Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 88.5676H44.8108V93.5405H39.8378V88.5676Z"
          fill="#1D153A"
        />
        <path
          d="M44.8108 88.5676H49.7838V93.5405H44.8108V88.5676Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 88.5676H54.7568V93.5405H49.7838V88.5676Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 88.5676H134.324V93.5405H129.351V88.5676Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 88.5676H149.243V93.5405H144.27V88.5676Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 88.5676H159.189V93.5405H154.216V88.5676Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 88.5676H164.162V93.5405H159.189V88.5676Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 88.5676H169.135V93.5405H164.162V88.5676Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 88.5676H179.081V93.5405H174.108V88.5676Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 88.5676H184.054V93.5405H179.081V88.5676Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 88.5676H189.027V93.5405H184.054V88.5676Z"
          fill="#1D153A"
        />
        <path
          d="M19.9459 93.5405H24.9189V98.5135H19.9459V93.5405Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 93.5405H29.8919V98.5135H24.9189V93.5405Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 93.5405H34.8649V98.5135H29.8919V93.5405Z"
          fill="#1D153A"
        />
        <path
          d="M44.8108 93.5405H49.7838V98.5135H44.8108V93.5405Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 93.5405H59.7297V98.5135H54.7568V93.5405Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 93.5405H139.297V98.5135H134.324V93.5405Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 93.5405H159.189V98.5135H154.216V93.5405Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 93.5405H164.162V98.5135H159.189V93.5405Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 93.5405H174.108V98.5135H169.135V93.5405Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 93.5405H179.081V98.5135H174.108V93.5405Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 93.5405H194V98.5135H189.027V93.5405Z"
          fill="#1D153A"
        />
        <path
          d="M14.973 98.5135H19.9459V103.486H14.973V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M19.9459 98.5135H24.9189V103.486H19.9459V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 98.5135H34.8649V103.486H29.8919V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 98.5135H39.8378V103.486H34.8649V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 98.5135H44.8108V103.486H39.8378V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 98.5135H59.7297V103.486H54.7568V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 98.5135H64.7027V103.486H59.7297V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 98.5135H69.6757V103.486H64.7027V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 98.5135H74.6487V103.486H69.6757V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 98.5135H134.324V103.486H129.351V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 98.5135H164.162V103.486H159.189V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 98.5135H169.135V103.486H164.162V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 98.5135H174.108V103.486H169.135V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 98.5135H179.081V103.486H174.108V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 98.5135H184.054V103.486H179.081V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 98.5135H189.027V103.486H184.054V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 98.5135H194V103.486H189.027V98.5135Z"
          fill="#1D153A"
        />
        <path
          d="M14.973 103.486H19.9459V108.459H14.973V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 103.486H29.8919V108.459H24.9189V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 103.486H34.8649V108.459H29.8919V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M44.8108 103.486H49.7838V108.459H44.8108V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 103.486H54.7568V108.459H49.7838V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 103.486H59.7297V108.459H54.7568V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 103.486H64.7027V108.459H59.7297V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 103.486H69.6757V108.459H64.7027V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 103.486H74.6487V108.459H69.6757V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 103.486H134.324V108.459H129.351V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 103.486H149.243V108.459H144.27V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 103.486H154.216V108.459H149.243V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 103.486H164.162V108.459H159.189V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 103.486H174.108V108.459H169.135V103.486Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 103.486H184.054V108.459H179.081V103.486Z"
          fill="#1D153A"
        />
        <path d="M10 108.459H14.973V113.432H10V108.459Z" fill="#1D153A" />
        <path
          d="M19.9459 108.459H24.9189V113.432H19.9459V108.459Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 108.459H39.8378V113.432H34.8649V108.459Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 108.459H44.8108V113.432H39.8378V108.459Z"
          fill="#1D153A"
        />
        <path
          d="M44.8108 108.459H49.7838V113.432H44.8108V108.459Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 108.459H59.7297V113.432H54.7568V108.459Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 108.459H64.7027V113.432H59.7297V108.459Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 108.459H139.297V113.432H134.324V108.459Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 108.459H144.27V113.432H139.297V108.459Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 108.459H154.216V113.432H149.243V108.459Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 108.459H164.162V113.432H159.189V108.459Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 108.459H169.135V113.432H164.162V108.459Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 108.459H174.108V113.432H169.135V108.459Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 108.459H194V113.432H189.027V108.459Z"
          fill="#1D153A"
        />
        <path d="M10 113.432H14.973V118.405H10V113.432Z" fill="#1D153A" />
        <path
          d="M19.9459 113.432H24.9189V118.405H19.9459V113.432Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 113.432H29.8919V118.405H24.9189V113.432Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 113.432H34.8649V118.405H29.8919V113.432Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 113.432H39.8378V118.405H34.8649V113.432Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 113.432H59.7297V118.405H54.7568V113.432Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 113.432H64.7027V118.405H59.7297V113.432Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 113.432H159.189V118.405H154.216V113.432Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 113.432H164.162V118.405H159.189V113.432Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 113.432H189.027V118.405H184.054V113.432Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 113.432H194V118.405H189.027V113.432Z"
          fill="#1D153A"
        />
        <path d="M10 118.405H14.973V123.378H10V118.405Z" fill="#1D153A" />
        <path
          d="M24.9189 118.405H29.8919V123.378H24.9189V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 118.405H39.8378V123.378H34.8649V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 118.405H44.8108V123.378H39.8378V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M44.8108 118.405H49.7838V123.378H44.8108V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 118.405H69.6757V123.378H64.7027V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 118.405H74.6487V123.378H69.6757V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 118.405H134.324V123.378H129.351V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 118.405H154.216V123.378H149.243V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 118.405H159.189V123.378H154.216V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 118.405H169.135V123.378H164.162V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 118.405H174.108V123.378H169.135V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 118.405H189.027V123.378H184.054V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 118.405H194V123.378H189.027V118.405Z"
          fill="#1D153A"
        />
        <path
          d="M14.973 123.378H19.9459V128.351H14.973V123.378Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 123.378H39.8378V128.351H34.8649V123.378Z"
          fill="#1D153A"
        />
        <path
          d="M44.8108 123.378H49.7838V128.351H44.8108V123.378Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 123.378H54.7568V128.351H49.7838V123.378Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 123.378H59.7297V128.351H54.7568V123.378Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 123.378H74.6487V128.351H69.6757V123.378Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 123.378H134.324V128.351H129.351V123.378Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 123.378H144.27V128.351H139.297V123.378Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 123.378H154.216V128.351H149.243V123.378Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 123.378H164.162V128.351H159.189V123.378Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 123.378H174.108V128.351H169.135V123.378Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 123.378H194V128.351H189.027V123.378Z"
          fill="#1D153A"
        />
        <path d="M10 128.351H14.973V133.324H10V128.351Z" fill="#1D153A" />
        <path
          d="M19.9459 128.351H24.9189V133.324H19.9459V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 128.351H34.8649V133.324H29.8919V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 128.351H44.8108V133.324H39.8378V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 128.351H59.7297V133.324H54.7568V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 128.351H69.6757V133.324H64.7027V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M74.6487 128.351H79.6216V133.324H74.6487V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 128.351H84.5946V133.324H79.6216V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 128.351H89.5676V133.324H84.5946V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M89.5676 128.351H94.5405V133.324H89.5676V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 128.351H99.5135V133.324H94.5405V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 128.351H109.459V133.324H104.486V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M114.432 128.351H119.405V133.324H114.432V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 128.351H134.324V133.324H129.351V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 128.351H149.243V133.324H144.27V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 128.351H159.189V133.324H154.216V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 128.351H179.081V133.324H174.108V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 128.351H189.027V133.324H184.054V128.351Z"
          fill="#1D153A"
        />
        <path
          d="M14.973 133.324H19.9459V138.297H14.973V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 133.324H29.8919V138.297H24.9189V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 133.324H34.8649V138.297H29.8919V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 133.324H39.8378V138.297H34.8649V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M44.8108 133.324H49.7838V138.297H44.8108V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 133.324H59.7297V138.297H54.7568V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 133.324H74.6487V138.297H69.6757V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 133.324H84.5946V138.297H79.6216V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 133.324H99.5135V138.297H94.5405V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M114.432 133.324H119.405V138.297H114.432V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M119.405 133.324H124.378V138.297H119.405V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M124.378 133.324H129.351V138.297H124.378V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 133.324H134.324V138.297H129.351V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 133.324H149.243V138.297H144.27V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 133.324H154.216V138.297H149.243V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 133.324H159.189V138.297H154.216V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 133.324H169.135V138.297H164.162V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 133.324H189.027V138.297H184.054V133.324Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 133.324H194V138.297H189.027V133.324Z"
          fill="#1D153A"
        />
        <path d="M10 138.297H14.973V143.27H10V138.297Z" fill="#1D153A" />
        <path
          d="M19.9459 138.297H24.9189V143.27H19.9459V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 138.297H44.8108V143.27H39.8378V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M44.8108 138.297H49.7838V143.27H44.8108V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 138.297H59.7297V143.27H54.7568V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 138.297H64.7027V143.27H59.7297V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 138.297H69.6757V143.27H64.7027V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 138.297H74.6487V143.27H69.6757V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 138.297H89.5676V143.27H84.5946V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 138.297H99.5135V143.27H94.5405V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 138.297H109.459V143.27H104.486V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M114.432 138.297H119.405V143.27H114.432V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M119.405 138.297H124.378V143.27H119.405V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 138.297H134.324V143.27H129.351V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 138.297H139.297V143.27H134.324V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 138.297H144.27V143.27H139.297V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 138.297H159.189V143.27H154.216V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 138.297H169.135V143.27H164.162V138.297Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 138.297H179.081V143.27H174.108V138.297Z"
          fill="#1D153A"
        />
        <path d="M189.027 138.297H194V143.27H189.027V138.297Z" fill="#1D153A" />
        <path
          d="M14.973 143.27H19.9459V148.243H14.973V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M19.9459 143.27H24.9189V148.243H19.9459V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 143.27H34.8649V148.243H29.8919V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 143.27H39.8378V148.243H34.8649V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 143.27H59.7297V148.243H54.7568V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 143.27H89.5676V148.243H84.5946V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 143.27H104.486V148.243H99.5135V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 143.27H109.459V148.243H104.486V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M114.432 143.27H119.405V148.243H114.432V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 143.27H134.324V148.243H129.351V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 143.27H139.297V148.243H134.324V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 143.27H144.27V148.243H139.297V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 143.27H149.243V148.243H144.27V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 143.27H159.189V148.243H154.216V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 143.27H164.162V148.243H159.189V143.27Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 143.27H169.135V148.243H164.162V143.27Z"
          fill="#1D153A"
        />
        <path d="M10 148.243H14.973V153.216H10V148.243Z" fill="#1D153A" />
        <path
          d="M14.973 148.243H19.9459V153.216H14.973V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 148.243H29.8919V153.216H24.9189V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 148.243H39.8378V153.216H34.8649V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 148.243H44.8108V153.216H39.8378V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 148.243H59.7297V153.216H54.7568V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 148.243H64.7027V153.216H59.7297V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M74.6487 148.243H79.6216V153.216H74.6487V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 148.243H89.5676V153.216H84.5946V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 148.243H99.5135V153.216H94.5405V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 148.243H104.486V153.216H99.5135V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 148.243H109.459V153.216H104.486V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M114.432 148.243H119.405V153.216H114.432V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M124.378 148.243H129.351V153.216H124.378V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 148.243H134.324V153.216H129.351V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 148.243H154.216V153.216H149.243V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 148.243H159.189V153.216H154.216V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 148.243H164.162V153.216H159.189V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 148.243H169.135V153.216H164.162V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 148.243H174.108V153.216H169.135V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 148.243H184.054V153.216H179.081V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 148.243H189.027V153.216H184.054V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 148.243H194V153.216H189.027V148.243Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 153.216H54.7568V158.189H49.7838V153.216Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 153.216H69.6757V158.189H64.7027V153.216Z"
          fill="#1D153A"
        />
        <path
          d="M74.6487 153.216H79.6216V158.189H74.6487V153.216Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 153.216H84.5946V158.189H79.6216V153.216Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 153.216H99.5135V158.189H94.5405V153.216Z"
          fill="#1D153A"
        />
        <path
          d="M119.405 153.216H124.378V158.189H119.405V153.216Z"
          fill="#1D153A"
        />
        <path
          d="M124.378 153.216H129.351V158.189H124.378V153.216Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 153.216H134.324V158.189H129.351V153.216Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 153.216H139.297V158.189H134.324V153.216Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 153.216H149.243V158.189H144.27V153.216Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 153.216H154.216V158.189H149.243V153.216Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 153.216H174.108V158.189H169.135V153.216Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 153.216H194V158.189H189.027V153.216Z"
          fill="#1D153A"
        />
        <path d="M10 158.189H14.973V163.162H10V158.189Z" fill="#1D153A" />
        <path
          d="M14.973 158.189H19.9459V163.162H14.973V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M19.9459 158.189H24.9189V163.162H19.9459V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 158.189H29.8919V163.162H24.9189V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 158.189H34.8649V163.162H29.8919V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 158.189H39.8378V163.162H34.8649V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 158.189H44.8108V163.162H39.8378V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 158.189H64.7027V163.162H59.7297V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 158.189H69.6757V163.162H64.7027V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 158.189H74.6487V163.162H69.6757V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M74.6487 158.189H79.6216V163.162H74.6487V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 158.189H84.5946V163.162H79.6216V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M89.5676 158.189H94.5405V163.162H89.5676V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M114.432 158.189H119.405V163.162H114.432V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 158.189H139.297V163.162H134.324V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 158.189H149.243V163.162H144.27V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 158.189H154.216V163.162H149.243V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 158.189H164.162V163.162H159.189V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 158.189H174.108V163.162H169.135V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 158.189H184.054V163.162H179.081V158.189Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 158.189H194V163.162H189.027V158.189Z"
          fill="#1D153A"
        />
        <path d="M10 163.162H14.973V168.135H10V163.162Z" fill="#1D153A" />
        <path
          d="M39.8378 163.162H44.8108V168.135H39.8378V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 163.162H59.7297V168.135H54.7568V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 163.162H64.7027V168.135H59.7297V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 163.162H74.6487V168.135H69.6757V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 163.162H84.5946V168.135H79.6216V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 163.162H89.5676V168.135H84.5946V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M89.5676 163.162H94.5405V168.135H89.5676V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 163.162H99.5135V168.135H94.5405V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 163.162H104.486V168.135H99.5135V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M129.351 163.162H134.324V168.135H129.351V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 163.162H154.216V168.135H149.243V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 163.162H174.108V168.135H169.135V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 163.162H184.054V168.135H179.081V163.162Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 163.162H194V168.135H189.027V163.162Z"
          fill="#1D153A"
        />
        <path d="M10 168.135H14.973V173.108H10V168.135Z" fill="#1D153A" />
        <path
          d="M19.9459 168.135H24.9189V173.108H19.9459V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 168.135H29.8919V173.108H24.9189V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 168.135H34.8649V173.108H29.8919V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 168.135H44.8108V173.108H39.8378V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 168.135H74.6487V173.108H69.6757V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 168.135H104.486V173.108H99.5135V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 168.135H109.459V173.108H104.486V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M109.459 168.135H114.432V173.108H109.459V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M124.378 168.135H129.351V173.108H124.378V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 168.135H139.297V173.108H134.324V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M139.297 168.135H144.27V173.108H139.297V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 168.135H154.216V173.108H149.243V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 168.135H159.189V173.108H154.216V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 168.135H164.162V173.108H159.189V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 168.135H169.135V173.108H164.162V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 168.135H174.108V173.108H169.135V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 168.135H179.081V173.108H174.108V168.135Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 168.135H194V173.108H189.027V168.135Z"
          fill="#1D153A"
        />
        <path d="M10 173.108H14.973V178.081H10V173.108Z" fill="#1D153A" />
        <path
          d="M19.9459 173.108H24.9189V178.081H19.9459V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 173.108H29.8919V178.081H24.9189V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 173.108H34.8649V178.081H29.8919V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 173.108H44.8108V178.081H39.8378V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M49.7838 173.108H54.7568V178.081H49.7838V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 173.108H64.7027V178.081H59.7297V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 173.108H69.6757V178.081H64.7027V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 173.108H74.6487V178.081H69.6757V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M74.6487 173.108H79.6216V178.081H74.6487V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 173.108H89.5676V178.081H84.5946V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 173.108H99.5135V178.081H94.5405V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 173.108H104.486V178.081H99.5135V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M124.378 173.108H129.351V178.081H124.378V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 173.108H154.216V178.081H149.243V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 173.108H159.189V178.081H154.216V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 173.108H169.135V178.081H164.162V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 173.108H174.108V178.081H169.135V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 173.108H184.054V178.081H179.081V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 173.108H189.027V178.081H184.054V173.108Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 173.108H194V178.081H189.027V173.108Z"
          fill="#1D153A"
        />
        <path d="M10 178.081H14.973V183.054H10V178.081Z" fill="#1D153A" />
        <path
          d="M19.9459 178.081H24.9189V183.054H19.9459V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 178.081H29.8919V183.054H24.9189V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 178.081H34.8649V183.054H29.8919V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 178.081H44.8108V183.054H39.8378V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M54.7568 178.081H59.7297V183.054H54.7568V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 178.081H64.7027V183.054H59.7297V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M69.6757 178.081H74.6487V183.054H69.6757V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M74.6487 178.081H79.6216V183.054H74.6487V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 178.081H84.5946V183.054H79.6216V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M84.5946 178.081H89.5676V183.054H84.5946V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 178.081H104.486V183.054H99.5135V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M104.486 178.081H109.459V183.054H104.486V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M114.432 178.081H119.405V183.054H114.432V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M119.405 178.081H124.378V183.054H119.405V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 178.081H149.243V183.054H144.27V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 178.081H154.216V183.054H149.243V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M164.162 178.081H169.135V183.054H164.162V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 178.081H174.108V183.054H169.135V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M179.081 178.081H184.054V183.054H179.081V178.081Z"
          fill="#1D153A"
        />
        <path
          d="M189.027 178.081H194V183.054H189.027V178.081Z"
          fill="#1D153A"
        />
        <path d="M10 183.054H14.973V188.027H10V183.054Z" fill="#1D153A" />
        <path
          d="M39.8378 183.054H44.8108V188.027H39.8378V183.054Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 183.054H64.7027V188.027H59.7297V183.054Z"
          fill="#1D153A"
        />
        <path
          d="M64.7027 183.054H69.6757V188.027H64.7027V183.054Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 183.054H84.5946V188.027H79.6216V183.054Z"
          fill="#1D153A"
        />
        <path
          d="M89.5676 183.054H94.5405V188.027H89.5676V183.054Z"
          fill="#1D153A"
        />
        <path
          d="M94.5405 183.054H99.5135V188.027H94.5405V183.054Z"
          fill="#1D153A"
        />
        <path
          d="M99.5135 183.054H104.486V188.027H99.5135V183.054Z"
          fill="#1D153A"
        />
        <path
          d="M114.432 183.054H119.405V188.027H114.432V183.054Z"
          fill="#1D153A"
        />
        <path
          d="M119.405 183.054H124.378V188.027H119.405V183.054Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 183.054H139.297V188.027H134.324V183.054Z"
          fill="#1D153A"
        />
        <path
          d="M144.27 183.054H149.243V188.027H144.27V183.054Z"
          fill="#1D153A"
        />
        <path
          d="M149.243 183.054H154.216V188.027H149.243V183.054Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 183.054H164.162V188.027H159.189V183.054Z"
          fill="#1D153A"
        />
        <path d="M10 188.027H14.973V193H10V188.027Z" fill="#1D153A" />
        <path d="M14.973 188.027H19.9459V193H14.973V188.027Z" fill="#1D153A" />
        <path
          d="M19.9459 188.027H24.9189V193H19.9459V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M24.9189 188.027H29.8919V193H24.9189V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M29.8919 188.027H34.8649V193H29.8919V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M34.8649 188.027H39.8378V193H34.8649V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M39.8378 188.027H44.8108V193H39.8378V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M59.7297 188.027H64.7027V193H59.7297V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M74.6487 188.027H79.6216V193H74.6487V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M79.6216 188.027H84.5946V193H79.6216V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M89.5676 188.027H94.5405V193H89.5676V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M109.459 188.027H114.432V193H109.459V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M114.432 188.027H119.405V193H114.432V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M134.324 188.027H139.297V193H134.324V188.027Z"
          fill="#1D153A"
        />
        <path d="M144.27 188.027H149.243V193H144.27V188.027Z" fill="#1D153A" />
        <path
          d="M149.243 188.027H154.216V193H149.243V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M154.216 188.027H159.189V193H154.216V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M159.189 188.027H164.162V193H159.189V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M169.135 188.027H174.108V193H169.135V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M174.108 188.027H179.081V193H174.108V188.027Z"
          fill="#1D153A"
        />
        <path
          d="M184.054 188.027H189.027V193H184.054V188.027Z"
          fill="#1D153A"
        />
        <path d="M189.027 188.027H194V193H189.027V188.027Z" fill="#1D153A" />
        <g mask="url(#mask0_2218_7445)">
          <path
            d="M33.5 222.129C33.5 221.918 33.5715 221.74 33.7144 221.594C33.8573 221.448 34.0344 221.375 34.2456 221.375C34.4569 221.375 34.6354 221.446 34.7812 221.589C34.9271 221.732 35 221.909 35 222.121C35 222.332 34.9285 222.51 34.7856 222.656C34.6427 222.802 34.4656 222.875 34.2544 222.875C34.0431 222.875 33.8646 222.804 33.7187 222.661C33.5729 222.518 33.5 222.341 33.5 222.129ZM33.5 225.254C33.5 225.043 33.5715 224.865 33.7144 224.719C33.8573 224.573 34.0344 224.5 34.2456 224.5C34.4569 224.5 34.6354 224.571 34.7812 224.714C34.9271 224.857 35 225.034 35 225.246C35 225.457 34.9285 225.635 34.7856 225.781C34.6427 225.927 34.4656 226 34.2544 226C34.0431 226 33.8646 225.929 33.7187 225.786C33.5729 225.643 33.5 225.466 33.5 225.254ZM30.375 225.254C30.375 225.043 30.4465 224.865 30.5894 224.719C30.7323 224.573 30.9094 224.5 31.1206 224.5C31.3319 224.5 31.5104 224.571 31.6562 224.714C31.8021 224.857 31.875 225.034 31.875 225.246C31.875 225.457 31.8035 225.635 31.6606 225.781C31.5177 225.927 31.3406 226 31.1294 226C30.9181 226 30.7396 225.929 30.5937 225.786C30.4479 225.643 30.375 225.466 30.375 225.254ZM27.25 225.254C27.25 225.043 27.3215 224.865 27.4644 224.719C27.6073 224.573 27.7844 224.5 27.9956 224.5C28.2069 224.5 28.3854 224.571 28.5312 224.714C28.6771 224.857 28.75 225.034 28.75 225.246C28.75 225.457 28.6785 225.635 28.5356 225.781C28.3927 225.927 28.2156 226 28.0044 226C27.7931 226 27.6146 225.929 27.4687 225.786C27.3229 225.643 27.25 225.466 27.25 225.254ZM24.125 225.254C24.125 225.043 24.1965 224.865 24.3394 224.719C24.4823 224.573 24.6594 224.5 24.8706 224.5C25.0819 224.5 25.2604 224.571 25.4062 224.714C25.5521 224.857 25.625 225.034 25.625 225.246C25.625 225.457 25.5535 225.635 25.4106 225.781C25.2677 225.927 25.0906 226 24.8794 226C24.6681 226 24.4896 225.929 24.3437 225.786C24.1979 225.643 24.125 225.466 24.125 225.254ZM21 222.129C21 221.918 21.0715 221.74 21.2144 221.594C21.3573 221.448 21.5344 221.375 21.7456 221.375C21.9569 221.375 22.1354 221.446 22.2812 221.589C22.4271 221.732 22.5 221.909 22.5 222.121C22.5 222.332 22.4285 222.51 22.2856 222.656C22.1427 222.802 21.9656 222.875 21.7544 222.875C21.5431 222.875 21.3646 222.804 21.2187 222.661C21.0729 222.518 21 222.341 21 222.129ZM21 225.254C21 225.043 21.0715 224.865 21.2144 224.719C21.3573 224.573 21.5344 224.5 21.7456 224.5C21.9569 224.5 22.1354 224.571 22.2812 224.714C22.4271 224.857 22.5 225.034 22.5 225.246C22.5 225.457 22.4285 225.635 22.2856 225.781C22.1427 225.927 21.9656 226 21.7544 226C21.5431 226 21.3646 225.929 21.2187 225.786C21.0729 225.643 21 225.466 21 225.254ZM21 213.5C21 213.087 21.1469 212.734 21.4406 212.441C21.7344 212.147 22.0875 212 22.5 212L33.5 212C33.9125 212 34.2656 212.147 34.5594 212.441C34.8531 212.734 35 213.087 35 213.5L35 216.271C35 216.483 34.9285 216.661 34.7856 216.805C34.6427 216.949 34.4656 217.021 34.2544 217.021C34.0431 217.021 33.8646 216.949 33.7187 216.805C33.5729 216.661 33.5 216.483 33.5 216.271L33.5 213.5L22.5 213.5L22.5 216.271C22.5 216.483 22.4285 216.661 22.2856 216.805C22.1427 216.949 21.9656 217.021 21.7544 217.021C21.5431 217.021 21.3646 216.949 21.2187 216.805C21.0729 216.661 21 216.483 21 216.271L21 213.5ZM19.75 218.25L36.25 218.25C36.4625 218.25 36.6406 218.321 36.7844 218.464C36.9281 218.607 37 218.784 37 218.996C37 219.207 36.9281 219.385 36.7844 219.531C36.6406 219.677 36.4625 219.75 36.25 219.75L19.75 219.75C19.5375 219.75 19.3594 219.679 19.2156 219.536C19.0719 219.393 19 219.216 19 219.004C19 218.793 19.0719 218.615 19.2156 218.469C19.3594 218.323 19.5375 218.25 19.75 218.25Z"
            fill="#423767"
          />
        </g>
        <path
          d="M53.952 216.116C53.8773 216.041 53.7387 215.94 53.536 215.812C53.344 215.684 53.104 215.561 52.816 215.444C52.5387 215.327 52.2347 215.225 51.904 215.14C51.5733 215.044 51.2373 214.996 50.896 214.996C50.2987 214.996 49.8453 215.108 49.536 215.332C49.2373 215.556 49.088 215.871 49.088 216.276C49.088 216.585 49.184 216.831 49.376 217.012C49.568 217.193 49.856 217.348 50.24 217.476C50.624 217.604 51.104 217.743 51.68 217.892C52.4267 218.073 53.072 218.297 53.616 218.564C54.1707 218.82 54.592 219.161 54.88 219.588C55.1787 220.004 55.328 220.559 55.328 221.252C55.328 221.86 55.216 222.383 54.992 222.82C54.768 223.247 54.4587 223.593 54.064 223.86C53.6693 224.127 53.2213 224.324 52.72 224.452C52.2187 224.569 51.6853 224.628 51.12 224.628C50.5547 224.628 49.9893 224.569 49.424 224.452C48.8587 224.335 48.3147 224.169 47.792 223.956C47.2693 223.732 46.7893 223.465 46.352 223.156L47.328 221.252C47.424 221.348 47.5947 221.476 47.84 221.636C48.0853 221.785 48.384 221.94 48.736 222.1C49.088 222.249 49.472 222.377 49.888 222.484C50.304 222.591 50.7253 222.644 51.152 222.644C51.7493 222.644 52.2027 222.543 52.512 222.34C52.8213 222.137 52.976 221.849 52.976 221.476C52.976 221.135 52.8533 220.868 52.608 220.676C52.3627 220.484 52.0213 220.319 51.584 220.18C51.1467 220.031 50.6293 219.871 50.032 219.7C49.3173 219.497 48.72 219.273 48.24 219.028C47.76 218.772 47.4027 218.452 47.168 218.068C46.9333 217.684 46.816 217.204 46.816 216.628C46.816 215.849 46.9973 215.199 47.36 214.676C47.7333 214.143 48.2347 213.743 48.864 213.476C49.4933 213.199 50.192 213.06 50.96 213.06C51.4933 213.06 51.9947 213.119 52.464 213.236C52.944 213.353 53.392 213.508 53.808 213.7C54.224 213.892 54.5973 214.1 54.928 214.324L53.952 216.116ZM60.6925 224.66C60.0098 224.66 59.3965 224.548 58.8525 224.324C58.3085 224.089 57.8445 223.769 57.4605 223.364C57.0765 222.948 56.7778 222.479 56.5645 221.956C56.3618 221.433 56.2605 220.884 56.2605 220.308C56.2605 219.519 56.4365 218.799 56.7885 218.148C57.1512 217.487 57.6632 216.959 58.3245 216.564C58.9858 216.169 59.7698 215.972 60.6765 215.972C61.5832 215.972 62.3618 216.169 63.0125 216.564C63.6632 216.959 64.1485 217.476 64.4685 218.116L62.3725 218.756C62.1912 218.447 61.9512 218.212 61.6525 218.052C61.3538 217.881 61.0232 217.796 60.6605 217.796C60.2552 217.796 59.8818 217.903 59.5405 218.116C59.2098 218.319 58.9485 218.612 58.7565 218.996C58.5645 219.369 58.4685 219.807 58.4685 220.308C58.4685 220.799 58.5645 221.236 58.7565 221.62C58.9592 221.993 59.2258 222.292 59.5565 222.516C59.8872 222.729 60.2552 222.836 60.6605 222.836C60.9165 222.836 61.1565 222.793 61.3805 222.708C61.6152 222.623 61.8232 222.505 62.0045 222.356C62.1858 222.207 62.3192 222.036 62.4045 221.844L64.5005 222.484C64.3085 222.9 64.0258 223.273 63.6525 223.604C63.2898 223.935 62.8578 224.196 62.3565 224.388C61.8658 224.569 61.3112 224.66 60.6925 224.66ZM65.2438 222.02C65.2438 221.476 65.3931 221.001 65.6918 220.596C66.0011 220.18 66.4278 219.86 66.9718 219.636C67.5158 219.412 68.1398 219.3 68.8438 219.3C69.1958 219.3 69.5531 219.327 69.9158 219.38C70.2784 219.433 70.5931 219.519 70.8598 219.636V219.188C70.8598 218.655 70.6998 218.244 70.3798 217.956C70.0704 217.668 69.6064 217.524 68.9878 217.524C68.5291 217.524 68.0918 217.604 67.6758 217.764C67.2598 217.924 66.8224 218.159 66.3638 218.468L65.6758 217.06C66.2304 216.697 66.7958 216.425 67.3718 216.244C67.9584 216.063 68.5718 215.972 69.2118 215.972C70.4064 215.972 71.3344 216.271 71.9958 216.868C72.6678 217.465 73.0038 218.319 73.0038 219.428V222.1C73.0038 222.324 73.0411 222.484 73.1158 222.58C73.2011 222.676 73.3344 222.735 73.5158 222.756V224.5C73.3238 224.532 73.1478 224.559 72.9878 224.58C72.8384 224.601 72.7104 224.612 72.6038 224.612C72.1771 224.612 71.8518 224.516 71.6278 224.324C71.4144 224.132 71.2811 223.897 71.2278 223.62L71.1798 223.188C70.8171 223.657 70.3638 224.02 69.8198 224.276C69.2758 224.532 68.7211 224.66 68.1558 224.66C67.6011 224.66 67.0998 224.548 66.6518 224.324C66.2144 224.089 65.8678 223.775 65.6118 223.38C65.3664 222.975 65.2438 222.521 65.2438 222.02ZM70.4598 222.452C70.5771 222.324 70.6731 222.196 70.7478 222.068C70.8224 221.94 70.8598 221.823 70.8598 221.716V220.868C70.6038 220.761 70.3264 220.681 70.0278 220.628C69.7291 220.564 69.4464 220.532 69.1798 220.532C68.6251 220.532 68.1664 220.655 67.8038 220.9C67.4518 221.135 67.2758 221.449 67.2758 221.844C67.2758 222.057 67.3344 222.26 67.4518 222.452C67.5691 222.644 67.7398 222.799 67.9638 222.916C68.1878 223.033 68.4544 223.092 68.7638 223.092C69.0838 223.092 69.3984 223.033 69.7078 222.916C70.0171 222.788 70.2678 222.633 70.4598 222.452ZM82.7993 224.5H80.6553V219.796C80.6553 219.124 80.5379 218.633 80.3033 218.324C80.0686 218.015 79.7433 217.86 79.3273 217.86C79.0393 217.86 78.7459 217.935 78.4473 218.084C78.1593 218.233 77.8979 218.441 77.6633 218.708C77.4286 218.964 77.2579 219.263 77.1513 219.604V224.5H75.0073V216.116H76.9433V217.668C77.1566 217.305 77.4286 217.001 77.7593 216.756C78.0899 216.5 78.4686 216.308 78.8953 216.18C79.3326 216.041 79.7913 215.972 80.2713 215.972C80.7939 215.972 81.2206 216.068 81.5513 216.26C81.8926 216.441 82.1486 216.692 82.3193 217.012C82.5006 217.321 82.6233 217.673 82.6873 218.068C82.7619 218.463 82.7993 218.863 82.7993 219.268V224.5ZM93.5313 224.068C93.3499 224.143 93.1313 224.228 92.8753 224.324C92.6193 224.42 92.3419 224.495 92.0433 224.548C91.7553 224.612 91.4619 224.644 91.1633 224.644C90.7686 224.644 90.4059 224.575 90.0753 224.436C89.7446 224.297 89.4779 224.079 89.2753 223.78C89.0833 223.471 88.9873 223.071 88.9873 222.58V217.764H87.8833V216.116H88.9873V213.396H91.1313V216.116H92.8913V217.764H91.1313V221.86C91.1419 222.148 91.2219 222.356 91.3713 222.484C91.5206 222.612 91.7073 222.676 91.9313 222.676C92.1553 222.676 92.3739 222.639 92.5873 222.564C92.8006 222.489 92.9713 222.425 93.0993 222.372L93.5313 224.068ZM98.4261 224.66C97.7435 224.66 97.1301 224.548 96.5861 224.324C96.0421 224.089 95.5781 223.769 95.1941 223.364C94.8208 222.959 94.5328 222.495 94.3301 221.972C94.1275 221.449 94.0261 220.9 94.0261 220.324C94.0261 219.737 94.1275 219.183 94.3301 218.66C94.5328 218.137 94.8208 217.673 95.1941 217.268C95.5781 216.863 96.0421 216.548 96.5861 216.324C97.1301 216.089 97.7435 215.972 98.4261 215.972C99.1088 215.972 99.7168 216.089 100.25 216.324C100.794 216.548 101.258 216.863 101.642 217.268C102.026 217.673 102.314 218.137 102.506 218.66C102.709 219.183 102.81 219.737 102.81 220.324C102.81 220.9 102.709 221.449 102.506 221.972C102.314 222.495 102.026 222.959 101.642 223.364C101.269 223.769 100.81 224.089 100.266 224.324C99.7221 224.548 99.1088 224.66 98.4261 224.66ZM96.2341 220.324C96.2341 220.815 96.3301 221.252 96.5221 221.636C96.7141 222.009 96.9755 222.303 97.3061 222.516C97.6368 222.729 98.0101 222.836 98.4261 222.836C98.8315 222.836 99.1995 222.729 99.5301 222.516C99.8608 222.292 100.122 221.993 100.314 221.62C100.517 221.236 100.618 220.799 100.618 220.308C100.618 219.828 100.517 219.396 100.314 219.012C100.122 218.628 99.8608 218.329 99.5301 218.116C99.1995 217.903 98.8315 217.796 98.4261 217.796C98.0101 217.796 97.6368 217.908 97.3061 218.132C96.9755 218.345 96.7141 218.644 96.5221 219.028C96.3301 219.401 96.2341 219.833 96.2341 220.324ZM107.589 220.308C107.589 219.497 107.749 218.767 108.069 218.116C108.389 217.455 108.832 216.932 109.397 216.548C109.962 216.164 110.608 215.972 111.333 215.972C111.952 215.972 112.506 216.127 112.997 216.436C113.498 216.735 113.888 217.119 114.165 217.588V212.82H116.309V222.1C116.309 222.324 116.346 222.484 116.421 222.58C116.496 222.676 116.624 222.735 116.805 222.756V224.5C116.432 224.575 116.128 224.612 115.893 224.612C115.509 224.612 115.189 224.516 114.933 224.324C114.688 224.132 114.549 223.881 114.517 223.572L114.485 223.044C114.176 223.567 113.754 223.967 113.221 224.244C112.698 224.521 112.149 224.66 111.573 224.66C110.997 224.66 110.464 224.548 109.973 224.324C109.493 224.1 109.072 223.791 108.709 223.396C108.357 223.001 108.08 222.543 107.877 222.02C107.685 221.487 107.589 220.916 107.589 220.308ZM114.165 221.428V219.428C114.058 219.119 113.888 218.841 113.653 218.596C113.418 218.351 113.157 218.159 112.869 218.02C112.581 217.871 112.293 217.796 112.005 217.796C111.674 217.796 111.376 217.865 111.109 218.004C110.842 218.143 110.608 218.329 110.405 218.564C110.213 218.799 110.064 219.071 109.957 219.38C109.861 219.689 109.813 220.015 109.813 220.356C109.813 220.697 109.866 221.023 109.973 221.332C110.09 221.631 110.256 221.892 110.469 222.116C110.682 222.34 110.928 222.516 111.205 222.644C111.493 222.772 111.802 222.836 112.133 222.836C112.336 222.836 112.538 222.804 112.741 222.74C112.954 222.665 113.152 222.569 113.333 222.452C113.525 222.324 113.69 222.175 113.829 222.004C113.978 221.823 114.09 221.631 114.165 221.428ZM122.286 224.66C121.603 224.66 120.99 224.548 120.446 224.324C119.902 224.089 119.438 223.769 119.054 223.364C118.68 222.959 118.392 222.495 118.19 221.972C117.987 221.449 117.886 220.9 117.886 220.324C117.886 219.737 117.987 219.183 118.19 218.66C118.392 218.137 118.68 217.673 119.054 217.268C119.438 216.863 119.902 216.548 120.446 216.324C120.99 216.089 121.603 215.972 122.286 215.972C122.968 215.972 123.576 216.089 124.11 216.324C124.654 216.548 125.118 216.863 125.502 217.268C125.886 217.673 126.174 218.137 126.366 218.66C126.568 219.183 126.67 219.737 126.67 220.324C126.67 220.9 126.568 221.449 126.366 221.972C126.174 222.495 125.886 222.959 125.502 223.364C125.128 223.769 124.67 224.089 124.126 224.324C123.582 224.548 122.968 224.66 122.286 224.66ZM120.094 220.324C120.094 220.815 120.19 221.252 120.382 221.636C120.574 222.009 120.835 222.303 121.166 222.516C121.496 222.729 121.87 222.836 122.286 222.836C122.691 222.836 123.059 222.729 123.39 222.516C123.72 222.292 123.982 221.993 124.174 221.62C124.376 221.236 124.478 220.799 124.478 220.308C124.478 219.828 124.376 219.396 124.174 219.012C123.982 218.628 123.72 218.329 123.39 218.116C123.059 217.903 122.691 217.796 122.286 217.796C121.87 217.796 121.496 217.908 121.166 218.132C120.835 218.345 120.574 218.644 120.382 219.028C120.19 219.401 120.094 219.833 120.094 220.324ZM138.235 216.116H140.267L136.763 224.5H134.971L133.563 220.9L132.187 224.5H130.379L126.891 216.116H128.907L131.403 222.452L132.379 219.716L130.923 216.132H132.699L133.563 218.692L134.443 216.132H136.219L134.763 219.716L135.755 222.452L138.235 216.116ZM149.049 224.5H146.905V219.796C146.905 219.124 146.788 218.633 146.553 218.324C146.319 218.015 145.993 217.86 145.577 217.86C145.289 217.86 144.996 217.935 144.697 218.084C144.409 218.233 144.148 218.441 143.913 218.708C143.679 218.964 143.508 219.263 143.401 219.604V224.5H141.257V216.116H143.193V217.668C143.407 217.305 143.679 217.001 144.009 216.756C144.34 216.5 144.719 216.308 145.145 216.18C145.583 216.041 146.041 215.972 146.521 215.972C147.044 215.972 147.471 216.068 147.801 216.26C148.143 216.441 148.399 216.692 148.569 217.012C148.751 217.321 148.873 217.673 148.937 218.068C149.012 218.463 149.049 218.863 149.049 219.268V224.5ZM150.898 212.82H153.042V221.812C153.042 222.196 153.106 222.457 153.234 222.596C153.362 222.724 153.538 222.788 153.762 222.788C153.932 222.788 154.108 222.767 154.29 222.724C154.471 222.681 154.631 222.628 154.77 222.564L155.058 224.196C154.77 224.335 154.434 224.441 154.049 224.516C153.666 224.591 153.319 224.628 153.01 224.628C152.338 224.628 151.815 224.452 151.442 224.1C151.079 223.737 150.898 223.225 150.898 222.564V212.82ZM159.864 224.66C159.181 224.66 158.568 224.548 158.024 224.324C157.48 224.089 157.016 223.769 156.632 223.364C156.258 222.959 155.97 222.495 155.768 221.972C155.565 221.449 155.464 220.9 155.464 220.324C155.464 219.737 155.565 219.183 155.768 218.66C155.97 218.137 156.258 217.673 156.632 217.268C157.016 216.863 157.48 216.548 158.024 216.324C158.568 216.089 159.181 215.972 159.864 215.972C160.546 215.972 161.154 216.089 161.688 216.324C162.232 216.548 162.696 216.863 163.08 217.268C163.464 217.673 163.752 218.137 163.944 218.66C164.146 219.183 164.248 219.737 164.248 220.324C164.248 220.9 164.146 221.449 163.944 221.972C163.752 222.495 163.464 222.959 163.08 223.364C162.706 223.769 162.248 224.089 161.704 224.324C161.16 224.548 160.546 224.66 159.864 224.66ZM157.672 220.324C157.672 220.815 157.768 221.252 157.96 221.636C158.152 222.009 158.413 222.303 158.744 222.516C159.074 222.729 159.448 222.836 159.864 222.836C160.269 222.836 160.637 222.729 160.968 222.516C161.298 222.292 161.56 221.993 161.752 221.62C161.954 221.236 162.056 220.799 162.056 220.308C162.056 219.828 161.954 219.396 161.752 219.012C161.56 218.628 161.298 218.329 160.968 218.116C160.637 217.903 160.269 217.796 159.864 217.796C159.448 217.796 159.074 217.908 158.744 218.132C158.413 218.345 158.152 218.644 157.96 219.028C157.768 219.401 157.672 219.833 157.672 220.324ZM165.119 222.02C165.119 221.476 165.268 221.001 165.567 220.596C165.876 220.18 166.303 219.86 166.847 219.636C167.391 219.412 168.015 219.3 168.719 219.3C169.071 219.3 169.428 219.327 169.791 219.38C170.153 219.433 170.468 219.519 170.735 219.636V219.188C170.735 218.655 170.575 218.244 170.255 217.956C169.945 217.668 169.481 217.524 168.863 217.524C168.404 217.524 167.967 217.604 167.551 217.764C167.135 217.924 166.697 218.159 166.239 218.468L165.551 217.06C166.105 216.697 166.671 216.425 167.247 216.244C167.833 216.063 168.447 215.972 169.087 215.972C170.281 215.972 171.209 216.271 171.871 216.868C172.543 217.465 172.879 218.319 172.879 219.428V222.1C172.879 222.324 172.916 222.484 172.991 222.58C173.076 222.676 173.209 222.735 173.391 222.756V224.5C173.199 224.532 173.023 224.559 172.863 224.58C172.713 224.601 172.585 224.612 172.479 224.612C172.052 224.612 171.727 224.516 171.503 224.324C171.289 224.132 171.156 223.897 171.103 223.62L171.055 223.188C170.692 223.657 170.239 224.02 169.695 224.276C169.151 224.532 168.596 224.66 168.031 224.66C167.476 224.66 166.975 224.548 166.527 224.324C166.089 224.089 165.743 223.775 165.487 223.38C165.241 222.975 165.119 222.521 165.119 222.02ZM170.335 222.452C170.452 222.324 170.548 222.196 170.623 222.068C170.697 221.94 170.735 221.823 170.735 221.716V220.868C170.479 220.761 170.201 220.681 169.903 220.628C169.604 220.564 169.321 220.532 169.055 220.532C168.5 220.532 168.041 220.655 167.679 220.9C167.327 221.135 167.151 221.449 167.151 221.844C167.151 222.057 167.209 222.26 167.327 222.452C167.444 222.644 167.615 222.799 167.839 222.916C168.063 223.033 168.329 223.092 168.639 223.092C168.959 223.092 169.273 223.033 169.583 222.916C169.892 222.788 170.143 222.633 170.335 222.452ZM174.37 220.308C174.37 219.497 174.53 218.767 174.85 218.116C175.17 217.455 175.613 216.932 176.178 216.548C176.744 216.164 177.389 215.972 178.114 215.972C178.733 215.972 179.288 216.127 179.778 216.436C180.28 216.735 180.669 217.119 180.946 217.588V212.82H183.09V222.1C183.09 222.324 183.128 222.484 183.202 222.58C183.277 222.676 183.405 222.735 183.586 222.756V224.5C183.213 224.575 182.909 224.612 182.674 224.612C182.29 224.612 181.97 224.516 181.714 224.324C181.469 224.132 181.33 223.881 181.298 223.572L181.266 223.044C180.957 223.567 180.536 223.967 180.002 224.244C179.48 224.521 178.93 224.66 178.354 224.66C177.778 224.66 177.245 224.548 176.754 224.324C176.274 224.1 175.853 223.791 175.49 223.396C175.138 223.001 174.861 222.543 174.658 222.02C174.466 221.487 174.37 220.916 174.37 220.308ZM180.946 221.428V219.428C180.84 219.119 180.669 218.841 180.434 218.596C180.2 218.351 179.938 218.159 179.65 218.02C179.362 217.871 179.074 217.796 178.786 217.796C178.456 217.796 178.157 217.865 177.89 218.004C177.624 218.143 177.389 218.329 177.186 218.564C176.994 218.799 176.845 219.071 176.738 219.38C176.642 219.689 176.594 220.015 176.594 220.356C176.594 220.697 176.648 221.023 176.754 221.332C176.872 221.631 177.037 221.892 177.25 222.116C177.464 222.34 177.709 222.516 177.986 222.644C178.274 222.772 178.584 222.836 178.914 222.836C179.117 222.836 179.32 222.804 179.522 222.74C179.736 222.665 179.933 222.569 180.114 222.452C180.306 222.324 180.472 222.175 180.61 222.004C180.76 221.823 180.872 221.631 180.946 221.428Z"
          fill="#423767"
        />
      </g>
      <rect x="1" y="0.5" width="201" height="241" rx="16.5" stroke="#DFE4EA" />
      <defs>
        <clipPath id="clip0_2218_7445">
          <rect x="1.5" y="1" width="200" height="240" rx="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default AndroidQR;
